import get from 'lodash/get';
import { pageTypes, ModalTypes } from 'constants/pageTypes';
import { PAGE_DATA_ACTIONS, MODAL_PAGE_DATA_ACTIONS } from 'actions/pageActionsV4';
import { SlotType } from '@rome/response/page/v4/SlotType';
import { WidgetTypeV4 } from '@rome/response/page/v4/WidgetTypeV4';
import { MediaType } from '@rome/response/enums/MediaType';
function extractMetadata(slots) {
    const output = {
        pincode: '',
        modulePresence: '',
        videoTracking: '',
        easySize: '',
        events: [],
        swatchIds: '',
        breadcrumbs: [],
        speed: ''
    };
    const modules = ['PP_RView'];
    const len = slots.length;
    for (let i = 0; i < len; i++) {
        const slot = slots[i];
        // proceed further only when the slot is an actual widget
        if (slot.slotType !== SlotType.WIDGET) {
            continue;
        }
        const widgetType = get(slot, 'widget.type');
        const widgetData = get(slot, 'widget.data');
        switch (widgetType) {
            /**
             * Extract out pincode
             */
            case WidgetTypeV4.COMPOSED_PINCODE_DELIVERY:
                output.pincode = get(widgetData, 'pincodeData.pincodeComponent.value.pincode');
                break;
            /**
             * Extract out pincode from new delivery widget (above maybe absent on new lifestyle layouts)
             */
            case WidgetTypeV4.DELIVERY_ADDRESS:
                if (output.pincode === '') {
                    output.pincode =
                        get(widgetData, 'addressInfo.address.pincode') || get(widgetData, 'pincodeInfo.pincode');
                }
                break;
            /**
             * Extract out speed information
             */
            case WidgetTypeV4.SELLER:
                output.speed = get(widgetData, 'deliveryMessages.0.value.speed');
                break;
            /**
             * 1. Check the viewType of SOLO_ACTION
             * 2. Check if its enabled
             */
            case WidgetTypeV4.SOLO_ACTION:
                if (get(slot, 'widget.viewType') === 'COMPARE' && get(widgetData, 'action.value.enabled', false)) {
                    modules.push('PP_VCmp');
                }
                break;
            /**
             * Check if Quick Compare widget is available
             */
            case WidgetTypeV4.QUICK_COMPARE:
                modules.push('PP_QCmp');
                break;
            /**
             * Check if viewType matches GRID
             */
            case WidgetTypeV4.PMU_HORIZONTAL:
                if (get(slot, 'widget.viewType') === 'GRID') {
                    modules.push('PP_Similar');
                }
                break;
            case WidgetTypeV4.PMU_TAB:
                modules.push('PP_CGrp');
                break;
            case WidgetTypeV4.PHYSICAL_ATTACH:
                modules.push('PP_Bundle');
                break;
            case WidgetTypeV4.RPD:
                modules.push('PP_RPD');
                break;
            case WidgetTypeV4.PRODUCT_OFFERS:
                if (get(widgetData, 'emiDetails.emiInfo')) {
                    modules.push('PP_EMI');
                }
                break;
            case WidgetTypeV4.COLLECTION_PMU:
                modules.push('STL:PP_Collection');
                break;
            /**
             * Loop over multimediaComponents and get the contentId for media type VIDEO
             **/
            case WidgetTypeV4.MULTIMEDIA:
                const videoTracking = [];
                (get(widgetData, 'multimediaComponents') || []).map((item, index) => {
                    if (get(item, 'value.contentType') === MediaType.VIDEO) {
                        videoTracking.push(`Video_TN_${index}_${get(item.value, 'contentId')}`);
                    }
                });
                output.videoTracking = videoTracking.join(';');
                break;
            /**
             * Extract out Product EasySize information
             */
            case WidgetTypeV4.COMPOSED_SWATCH:
                output.swatchIds = (get(widgetData, 'swatchComponent.value.attributes') || [])
                    .map(item => item.id)
                    .map((itemId, index) => {
                    const swatchValues = (get(widgetData, `swatchComponent.value.attributeOptions.${index}`) || []).map(option => option.value);
                    return `${itemId}:${swatchValues.join(',')}`;
                })
                    .join(';');
                // Extract out product easy size information
                break;
            case WidgetTypeV4.PRODUCT_BREADCRUMBS:
                output.breadcrumbs = get(widgetData, 'productBreadcrumbs');
                break;
            default:
                break;
        }
    }
    output.modulePresence = modules.join(';');
    return output;
}
export default function (state = {}, action) {
    switch (action.type) {
        case PAGE_DATA_ACTIONS.SUCCESS:
        case MODAL_PAGE_DATA_ACTIONS.SUCCESS:
            const { modalOptions } = action;
            const { type = '' } = modalOptions || {};
            let slots = get(action, 'data.slots');
            if (!slots)
                return state;
            if ((action.pageType && action.pageType === pageTypes.Product) || type === ModalTypes.QUICK_VIEW) {
                return extractMetadata(slots);
            }
            return {};
        case PAGE_DATA_ACTIONS.REQUEST:
        case PAGE_DATA_ACTIONS.ERROR:
        case PAGE_DATA_ACTIONS.CLEAR:
        case MODAL_PAGE_DATA_ACTIONS.REQUEST:
        case MODAL_PAGE_DATA_ACTIONS.ERROR:
            return {};
        default:
            return state;
    }
}
